import { DataVersion } from '@hakimo-ui/hakimo/types';
import { ShareResource } from '@hakimo-ui/hakimo/feature-shared';
import { isUnifiedDataVersion } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import AlarmFeedback from './alarm-feedback/AlarmFeedback';
import BugReportModal from './bug-report-modal/BugReportModal';
import PageMenu from './page-menu/PageMenu';

interface Props {
  alarmId: string;
  product: 'scan' | 'rg';
  onRefresh: () => void;
  sharedToken?: string;
  timestamp: string;
  dataVersion?: DataVersion;
}

export function PageActions(props: Props) {
  const { alarmId, product, sharedToken, onRefresh, timestamp, dataVersion } =
    props;
  const [openFeedback, setOpenFeedback] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [openBugReport, setOpenBugReport] = useState(false);

  return (
    <div className="flex">
      <Button variant="icon" onClick={onRefresh}>
        <ArrowPathIcon className="h-5 w-5" />
      </Button>

      {!sharedToken && (
        <div>
          <PageMenu
            product={product}
            onOpenFeedback={() => setOpenFeedback(true)}
            onOpenShareAlarm={() => setOpenShare(true)}
            onOpenBugReport={() => setOpenBugReport(true)}
          />

          {product === 'rg' && openFeedback && (
            <AlarmFeedback
              alarmId={alarmId}
              onClose={() => setOpenFeedback(false)}
              dataVersion={dataVersion}
            />
          )}
          {product === 'rg' && openBugReport && (
            <BugReportModal
              alarmId={alarmId}
              onClose={() => setOpenBugReport(false)}
              dataVersion={dataVersion}
            />
          )}

          {openShare && (
            <ShareResource
              resourceId={alarmId}
              // In v3 every raw alarm is RG, so it shares as an `alarm` even
              // though `product` reads 'scan' — that prop tracks the media
              // shape (v3 RG serves scan-style frames), not the product, and
              // sharing it as a scan raw alarm mints the token and opens the
              // shared route against the legacy scan dataset.
              resourceType={
                isUnifiedDataVersion(dataVersion) || product === 'rg'
                  ? 'alarm'
                  : 'scan-raw-alarm'
              }
              onClose={() => setOpenShare(false)}
              timestamp={timestamp}
              dataVersion={dataVersion}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default PageActions;
